module.exports = __webpack_public_path__ + "static/img/poster3.e7c833c4.png";